import { ScaleFrameFormat } from '../types'

export interface WeightReading {
  /** Kilograms. */
  kg: number
  stable: boolean
}

const TO_KG = { kg: 1, g: 0.001, lb: 0.45359237 } as const

/**
 * Finds the last complete reading in what the scale sent. The pattern comes from the catalog, so a new scale's output
 * is a System Admin entry, not code: e.g. `(?<stable>ST|US),GS,\s*(?<weight>[-\d.]+)\s*(?<unit>kg|g)`.
 */
export const parseScaleFrame = (text: string, format: ScaleFrameFormat): WeightReading | null => {
  const re = new RegExp(format.pattern, 'g')
  let last: RegExpExecArray | null = null
  for (let m = re.exec(text); m; m = re.exec(text)) {
    last = m
    if (m[0] === '') re.lastIndex++
  }
  const g = last?.groups
  if (!g?.weight) return null
  const value = Number(g.weight.replace(',', '.'))
  if (Number.isNaN(value)) return null
  const unit = (g.unit?.toLowerCase() as keyof typeof TO_KG) || format.unit
  const stable = format.stable_value ? g.stable === format.stable_value : true
  return { kg: Math.round(value * (TO_KG[unit] ?? TO_KG[format.unit]) * 1000) / 1000, stable }
}
